import { useHistory } from 'react-router-dom';
import React, { memo, useCallback } from 'react';
import arePropsEqual from 'react-fast-compare';
import NavigationList from '../components/NavigationList';
import NavigationListHeader from '../components/NavigationListHeader';
import { Local } from '../../../Local/Local';
import { useAnalyticsScreenName } from '../../../../hooks/useAnalyticsScreenName';
import { sendAnalyticsData } from '../../../../services/analytics';
import { getCategoriesRoute } from '../../../../utils/routes';
import type { SidebarNavigation } from '../types';
import { NAMESPACES } from '../../../../constants/namespaces';
import {
  ANALYTICS_SCHEMA_URLS,
  ANALYTICS_SCREEN_AREA_DETAILS,
  ANALYTICS_SCREEN_AREAS,
} from '../../../../constants/analytics';

type CategoriesNavigationProps = {
  isLoading: SidebarNavigation['isLoading'];
  items: SidebarNavigation['categories'];
  sectionIndex: number;
};

const ANALYTICS_DATA_ALL_CATEGORIES = {
  screen_area: ANALYTICS_SCREEN_AREAS.SIDEBAR,
  schema: ANALYTICS_SCHEMA_URLS.ALL_CLASSIFICATION_CLICK,
  screen_area_detail: ANALYTICS_SCREEN_AREA_DETAILS.ALL_CATEGORY,
};

const CategoriesNavigation = ({
  isLoading,
  items,
  sectionIndex,
}: CategoriesNavigationProps) => {
  const history = useHistory();
  const screenName = useAnalyticsScreenName();

  const onAllClick = useCallback(() => {
    sendAnalyticsData({
      ...ANALYTICS_DATA_ALL_CATEGORIES,
      section_index: sectionIndex,
      screen_name: screenName,
    });

    history.push(getCategoriesRoute());
  }, [history, screenName, sectionIndex]);

  return (
    <NavigationList
      items={items}
      isLoading={isLoading}
      sectionIndex={sectionIndex}
      header={
        <NavigationListHeader
          url={getCategoriesRoute()}
          onAllClick={onAllClick}
          title={<Local namespace={NAMESPACES.NAV}>Categories</Local>}
        />
      }
    />
  );
};
export default memo(CategoriesNavigation, arePropsEqual);
